import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { MembersToAddListCompass } from "./MembersToAddList";
import { MembersToAddListUIKit } from "./MembersToAddListUIKit";
import type { MembersToAddListProps } from "./types";

export const MembersToAddList = (props: MembersToAddListProps) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled(
    "circle_v4_data_table_enabled",
  );

  if (isCircleV4) {
    return <MembersToAddListCompass {...props} />;
  }

  return <MembersToAddListUIKit {...props} />;
};
